import api from "../core/api";

export const checkCouponValidity = async (body) => {
  return await api.post("coupons/check-validate", body);
};
